import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  CircularProgress,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from '../../../axiosConfig';

const CategoryProductPopup = ({ open, onClose, categories, onSave, activeCategory,fetchLatestDataAndMap }) => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewingProducts, setViewingProducts] = useState(false);
  const [currentCategoryProducts, setCurrentCategoryProducts] = useState([]);

  const handleCategoryToggle = (category) => {
    console.log("category.cat_product..",category);
    if(category.cat_products     && category.cat_products[0]){
      setCurrentCategoryProducts(category.cat_products);
      
    }else{
      setCurrentCategoryProducts([]);
    }
    setViewingProducts(true);
  };

  const handleProductToggle = (product) => {
    const currentIndex = selectedProducts.indexOf(product);
    const newChecked = [...selectedProducts];

    if (currentIndex === -1) {
      newChecked.push(product);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelectedProducts(newChecked);
  };

  const handleSave = async () => {
    setLoading(true);
    
    console.log("selectedProducts..",selectedProducts);
    try {
      let payload = {
        ProductId: selectedProducts.map((ele)=>ele.ProductId),
        CategoryId: activeCategory.CategoryId,
      }
  
      let updateCat = await axios.put(`/partners/menu_products`,payload)
      console.log("updateCat",updateCat);
      fetchLatestDataAndMap()
      onClose();
    } catch (error) {
      console.error('Error saving data', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {viewingProducts ? (
          <IconButton onClick={() => setViewingProducts(false)}>
            <ArrowBackIcon />
          </IconButton>
        ) : null}
        {viewingProducts ? 'Select Products' : 'Select Categories'}
      </DialogTitle>
      <DialogContent>
        <List>
          {viewingProducts
            ? currentCategoryProducts.map((product) => (
                <ListItem key={product.id} button onClick={() => handleProductToggle(product)}>
                  <ListItemText primary={product.name} />
                  <Checkbox
                    edge="end"
                    checked={selectedProducts.indexOf(product) !== -1}
                    tabIndex={-1}
                    disableRipple
                  />
                </ListItem>
              ))
            : categories.map((category) => (
                <ListItem key={category.id} button onClick={() => handleCategoryToggle(category)}>
                  <ListItemText primary={category.name} />
                  {/* <Checkbox
                    edge="end"
                    checked={selectedCategories.indexOf(category) !== -1}
                    tabIndex={-1}
                    disableRipple
                    onClick={() => {
                      const currentIndex = selectedCategories.indexOf(category);
                      const newChecked = [...selectedCategories];

                      if (currentIndex === -1) {
                        newChecked.push(category);
                      } else {
                        newChecked.splice(currentIndex, 1);
                      }

                      setSelectedCategories(newChecked);
                    }}
                  /> */}
                </ListItem>
              ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleSave} color="primary" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CategoryProductPopup;
